module.exports = __webpack_public_path__ + "static/img/12_智慧家電.0d2c299.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/button/12_智慧家電.png
// module id = MtcK
// module chunks = 1